import React from 'react';
import { Icon, IconComponent } from './icon';
import src from 'grpn-mx-mixer/dist/images/icons/plus-circle.svg';

export const IconPlusCircle: IconComponent = props => <Icon {...props} src={src} />;
